import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Message } from '../../interface';

@Component({
  selector: 'skypro-message-list',
  templateUrl: 'message-list.html',
  styleUrls: ['message-list.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MessageListComponent {
  @Input() messages: Message[];
  @Input() bigAttachmentPreview = false;

  identify(_index: number, item: Message): number {
    return item.id;
  }
}
